import React, { useEffect, useReducer, useState, useCallback } from "react";
import translate from "../../../i18n/translate";
import DailyNewsFeedComponent from "../../shared/DailyNewsFeedComponent/DailyNewsFeedComponent";
import { TransitionProps } from "@material-ui/core/transitions";
import ProductCard from "../../shared/ProductCard/ProductCard";
import RecomendedCarouselComponent from "../../shared/RecomendedCarouselComponent/RecomendedCarouselComponent";
import Toaster from "../../shared/Toaster/Toaster";
import H2SummaryBlock from "./../../shared/H2SummaryBlock/H2SummaryBlock";
import { useSelector, useDispatch } from "react-redux";
import "./LearnerHome.scss";
import { getCookieValue } from "../../../cookieHelper";
import { Button, Dialog, DialogTitle, Slide } from "@material-ui/core";
import RenewalIntercept from "../../shared/Intercepts/RenewalIntercept/RenewalIntercept";
import allActions from "../../../redux/actions";
import ManagerEmailPage from "../../shared/ManagerEmailPage/ManagerEmailPage";
import {
  dynamicCardProducts,
  monthList,
  productList,
  tmsProductIds,
  orderedDemoLicensesIds,
} from "./../../../globalConstants";
import { isEmailBitOn } from "../../../utils/FeatureBitCheck";
import { reorderDemoLicenses } from "../../../utils/reorderDemoLicenses";
import { getRandomNumber } from "../../shared/utils/sharedUtils";
import { moveReachLast, promoteDashboard } from "./LearnerHomeUtils";
import ProductCardSkeleton from "./ProductCardSkeleton";
import { hideToolsMenu } from "../../shared/Header/HeaderUtils";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const LearnerHome = (props: any) => {
  const allInfo = useSelector((state: any) => state);
  const { data } = useSelector((state: any) => state.jwkPublicKey);
  const { stepAuthorizationData } = useSelector((state: any) => state.progressDetails);
  const dispatch = useDispatch();
  const [GEProducts, setGEProducts] = useState([{}]);
  const [licensesList, setLicensesList] = useState([{}]);
  const [loaderFlag, setLoaderFlag] = useState(false);
  const [newsFeedList, setNewsFeedList] = useState([]);
  const [surveyWindowOpen, setSurveyWindowOpen] = useState(false);
  const [surveyURLFinal, setSurveyURLFinal] = useState("");
  const [surveyEndDate, setSurveyEndDate] = useState("");
  const[hideNewsFeed,setHideNewsFeed]=useState(false)
  let localLoginCalled = false;
  let localTMSCoursesCalled = false;

  let surveyPresent = false;
  const [toastOptions, settoastOptions] = useReducer((state: any, newState: any) => ({ ...state, ...newState }), {
    toastOpen: false,
    toastSeverity: "error",
    toastMessageKey: "",
  });

  useEffect(() => {
    if (data) getStepProgressResult();
  }, [data]);

  const getStepProgressResult = useCallback(async () => {
    const getUserToken = getCookieValue(`${process.env.REACT_APP_ENV}IdToken`);
    if (getUserToken && !stepAuthorizationData) {
      dispatch(allActions.progressDetailsAction.stepAuthorizationApiCall(getUserToken));
    }
  }, []);
  const handleToastOptionsDirect = (name: string, val: any) => {
    settoastOptions({ [name]: val });
  };
  const mapUrlsWithProducts = (filteredArr: any) => {
    let filteredArrWithRedirect = [];
    for (let i = 0; i < filteredArr.length; i++) {
      let eachProd = {
        ...filteredArr[i],
        show: "1",
        redirectURL: appendRedirectPortalURL(
          process.env[`REACT_APP_PRODUCT_URL_ID_${filteredArr[i].productId}`] || "",
        ),
      };
      filteredArrWithRedirect.push(eachProd);
    }
    return filteredArrWithRedirect;
  };

  const checkIfFeatureIsEnabled = (arr: string, featureBitNumber: number) => {
    return parseInt(arr[featureBitNumber]);
  };

  const filterLicenses = (resplicArr: Array<object>, features: string) => {
    let excludeIdsArr = JSON.parse(process.env.REACT_APP_EXCLUDE_PIDS || "") || [{}];
    if (checkIfFeatureIsEnabled(features, 55)) {
      excludeIdsArr.push(6);
    }
    const finFilteredArr = resplicArr.filter((product: any) => {
      return excludeIdsArr.indexOf(parseInt(product["productId"])) < 0 && product["active"] == 1;
    });
    return mapUrlsWithProducts(finFilteredArr);
  };

  const toasterHandle = (open: boolean, severity: string, messageKey: string) => {
    handleToastOptionsDirect("toastSeverity", severity);
    handleToastOptionsDirect("toastMessageKey", messageKey);
    handleToastOptionsDirect("toastOpen", open);
  };

  const checkIfTMSDependant = (edgeUid: string, username: string, licFilteredRespArr: Array<object>) => {
    if (GEProducts && GEProducts.length > 0 && Object.keys(GEProducts[0]).length <= 0) {
      setGEProducts(licFilteredRespArr);
    }
    let licensesArr: any = licFilteredRespArr || [];
    let finLicArray: any = [];
    if (licensesArr && licensesArr.length > 0) {
      finLicArray = licensesArr.filter((lic: any) => {
        return tmsProductIds.indexOf(lic.productId) >= 0;
      });
    }
    // <COMMENTING OUT CODE FOR TMS DEPENDENCY>
    const result = sessionStorage.getItem("isDemoUser")
      ? reorderDemoLicenses(licensesArr, orderedDemoLicensesIds)
      : "";
    if (finLicArray && finLicArray.length > 0 && allInfo.common.isTMSCallRequired) {
      getLearnerToken(edgeUid, username, licFilteredRespArr);
    } else {
      setLicensesList(licFilteredRespArr);
    }
    setLicensesList(licFilteredRespArr);
  };

  const getNewsFeedData = async () => {
    if (!allInfo.newsFeedAPI.data && props.isEnglishUser) {
      if (
        !allInfo.common.isNewsfeedTzBlocked &&
        allInfo.peopleInformation.data.getpeopleInformation.serviceConfiguration.features.substring(46, 47) === "1"
      ) {
        dispatch(allActions.newsFeedAPIActions.getNewsFeedAPI(4));
      }
    }
  };

  const getActiveCourse = async (userId: any, courseid: any) => {
    const uuId = allInfo.common.luuId;
    if (allInfo.peopleInformation && allInfo.peopleInformation.data) {
      const filteredSprintLevelLic = allInfo.peopleInformation.data.getpeopleInformation.license.filter((prod: any) => {
        return (
          prod.productId === "20" ||
          prod.productId === "26" ||
          prod.productId === "27" ||
          prod.productId === "28" ||
          prod.productId === "18" ||
          prod.productId === "25" ||
          prod.productId === "29"
        );
      });
      if (filteredSprintLevelLic && filteredSprintLevelLic.length > 0) {
        if (!allInfo.currentCourseDetails.data) {
          dispatch(
            allActions.currentCourseDetailsAction.getStoreActiveCourseInfo(
              userId,
              filteredSprintLevelLic[0].licenseId,
              filteredSprintLevelLic[0].productId,
              uuId,
              courseid
            )
          );
        }
        if (
          filteredSprintLevelLic &&
          filteredSprintLevelLic.length > 0 &&
          (filteredSprintLevelLic[0].productId == "25" ||
          filteredSprintLevelLic[0].productId == "29")
        ) {
          if (!allInfo.getLearnerDetails.data)
            dispatch(
              allActions.getLearnerDetailsAction.getLearnerDetails(userId, Number(filteredSprintLevelLic[0].productId))
            );
          if (!allInfo.getOtherTasks.data)
            dispatch(
              allActions.getOtherTasksAction.getOtherTasksAction(
                userId + "-" + filteredSprintLevelLic[0].licenseId,
                Number(filteredSprintLevelLic[0].productId)
              )
            );
          if (!allInfo.tmsLearnerSessions.data) {
            dispatch(allActions.tmsLearnerSessionsAction.getStoreTMSLearnerSessionInfo(allInfo.common.luuId));
          }
          if (!allInfo.createSessionService.data) {
            dispatch(allActions.createSessionServiceAction.createSessionService(courseid));
          }
        }
      }
    }
  };

  const getBusinessEnglishData = async (userId: any) => {
    const uuId = allInfo.common.luuId;
    const filteredSolo = allInfo.peopleInformation.data.getpeopleInformation.license.filter((prod: any) => {
      return prod.productId === "21" || prod.productId === "22" || prod.productId === "23" || prod.productId === "24";
    });
    if (filteredSolo && filteredSolo.length > 0) {
      if (!allInfo.currentCourseDetails.data) {
        dispatch(
          allActions.currentSoloCourseAction.getStoreSoloActiveCourseInfo(
            userId,
            filteredSolo[0].licenseId,
            filteredSolo[0].productId
          )
        );
      }
    }
  };

  const getLearnerToken = async (edgeUid: string, username: string, geProducts: any) => {
    const geId = allInfo.common.lgId;
    const uuId = allInfo.common.luuId;
    const iss = "ge_coach";
    if (!allInfo.learnerJWToken.data && !allInfo.learnerJWToken.isLoading) {
      dispatch(allActions.learnerJWTokenAction.getLearnerJWToken(geId, edgeUid, username, uuId, iss));
    } else {
      const orgFromWelcome: any = sessionStorage.getItem("orgFromWelcome");
      if (
        !allInfo.tmsCourses.isLoginLoading &&
        !allInfo.tmsCourses.isLogoutLoading &&
        !allInfo.tmsCourses.isLoading
      ) {
        if (!orgFromWelcome) {
          callTMSLogout();
        } else {
          sessionStorage.removeItem("orgFromWelcome");
        }
      }
    }
  };

  const callTMSLogin = async (learnerToken: string) => {
    if (!allInfo.tmsCourses.isLoginLoading) {
      if (!allInfo.tmsCourses.isLoginSucceeded) {
        if (!allInfo.tmsCourses.isLoginCalled) {
          if (!allInfo.tmsCourses.isLoading) {
            if (!localLoginCalled) {
              localLoginCalled = true;
              dispatch(allActions.tmsCoursesAction.callTMSLogin(learnerToken));
            }
          }
          if (!allInfo.tmsCourses.isLoading) {
            getTMSListInfo();
          }
        } else {
          getTMSListInfo();
        }
      } else {
        getTMSListInfo();
      }
    }
  };

  const appendRedirectPortalURL = (redirectURL: string) => {
    if (redirectURL.match(/.learnship./g)) {
      return redirectURL;
    } else {
      if (redirectURL.match(/reach/g)) {
        return redirectURL;
      }
    }
  };

  const callTMSLogout = async () => {
    if (!allInfo.tmsCourses.isLogoutLoading) {
      if (!allInfo.tmsCourses.isLogoutSucceeded) {
        if (!allInfo.tmsCourses.isLogoutCalled) {
          dispatch(allActions.tmsCoursesAction.callTMSLogOut());
        }
      } else {
        if (
          allInfo.learnerJWToken &&
          allInfo.learnerJWToken.data &&
          allInfo.learnerJWToken.data.getLearnerJwtoken
        ) {
          callTMSLogin(allInfo.learnerJWToken.data.getLearnerJwtoken);
        }
      }
    }
  };

  const filterRedundantGECourses = (preFinalList: any) => {
    let toExcludeArr: any = JSON.parse(process.env["REACT_APP_EXCLUDECOURSEPHRASES"] || "[]");
    for (let i = 0; i < preFinalList.length; i++) {
      for (let j = 0; j < toExcludeArr.length; j++) {
        let rExp = new RegExp(toExcludeArr[j], "i");
        if (Object.keys(preFinalList[i]).length > 0) {
          if (preFinalList[i].productName?.match(rExp)) {
            preFinalList[i].show = "0";
          }
        }
      }
    }
    return preFinalList;
  };

  const afterGetTMSCourse = (geProducts: any, resp: any) => {
    let finalProductsList: any = [];
    finalProductsList = geProducts;
    const shouldShowTMSCourses: boolean = (process.env.REACT_APP_SHOULD_SHOW_TMS_COURSES === "true");
    if (shouldShowTMSCourses) {
      if (resp && resp.data) {
        if (
          Object.prototype.toString.call(resp.data.getTMSGetCourse) === "[object Array]" &&
          resp.data.getTMSGetCourse.length > 0
        ) {
          let tmsConvertedProducts: any = [];
          resp.data.getTMSGetCourse.map((course: any) => {
            let geBluePrint = {
              active: `${course.status}` === "3" ? "1" : "0",
              endDate: "0000",
              licenseId: course.courseId || "00",
              productId: "",
              productName: course.courseName || "TMS",
              redirectURL: `${process.env["REACT_APP_TMS_URL"]}/index.php/subscriptionManagement/bookedPackageDetails?id=${course.courseId}`,
              startDate: "0000",
              status: course.status || "0",
              show: "1",
            };
            tmsConvertedProducts.push(geBluePrint);
          });
          finalProductsList = [...finalProductsList, ...tmsConvertedProducts];
        }
      }
    }
    setLicensesList(filterRedundantGECourses(finalProductsList));
  };

  const getTMSListInfo = async () => {
    const uuId = allInfo.common.luuId;
    if (!allInfo.tmsCourses.isLoading) {
      if (!allInfo.tmsCourses.data) {
        if (!allInfo.tmsCourses.isFailed) {
          if (!localTMSCoursesCalled) {
            localTMSCoursesCalled = true;
            if (!allInfo.tmsCourses.isLoading) {
              dispatch(allActions.tmsCoursesAction.getTMSCourses(uuId));
            }
          }
        } else {
          afterGetTMSCourse(GEProducts, allInfo.tmsCourses);
        }
      } else {
        afterGetTMSCourse(GEProducts, allInfo.tmsCourses);
      }
    }
  };

  const afterGetLearnerInfo = (resp: any) => {
    if (resp && resp.data) {
      checkIfTMSDependant(
        resp.data.getpeopleInformation.edgeUid || "0000",
        resp.data.getpeopleInformation.username,
        filterLicenses(
          resp.data.getpeopleInformation.license,
          resp.data.getpeopleInformation.serviceConfiguration.features
        )
      );
      const license = resp.data.getpeopleInformation.license;
      if (typeof license === "object" && license.length > 0){
        const fetchProductId = license.map((product:any) => {
          return product.productId;
        })
        if(fetchProductId.length ===1){
          const hideFeed = fetchProductId.some(hideToolsMenu) 
          setHideNewsFeed(hideFeed)
        }
      }
      dispatch(allActions.commonActions.setManagerEmail(resp.data.getpeopleInformation.managerEmail));
      const isManagerEmailRequired: any = isEmailBitOn(resp.data.getpeopleInformation, "Manager");
      dispatch(allActions.commonActions.setManagerEmailRequired(isManagerEmailRequired));
    }
  };

  const getDateFormat = (date: Date) => {
    return `${monthList[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
  };

  const afterGetAnnouncements = (resp: any, userId: string) => {
    const userLang: string = getCookieValue("ulang") || "";
    let respRaw = resp.data.getAnnouncements;
    if (respRaw !== null) {
      let notificationList = JSON.parse(
        JSON.parse(respRaw.announcement.replace(/^("\()/g, `"`).replace(/\);"$/g, `"`))
      );
      if (notificationList && notificationList.length > 0) {
        for (let i = 0; i < notificationList.length; i++) {
          if (notificationList[i].Type && parseInt(notificationList[i].Type) === 2) {
            surveyPresent = true;
            const currentNotification: any = notificationList[0];
            const [campId, surveyObjId] = currentNotification.Args;
            let surveyUrl = encodeURIComponent(
              `${
                process.env.REACT_APP_CORP_ENDPOINT
              }/templates/bin/template.asp?lang=${userLang.toUpperCase()}&ClassId=345&ObjectId=${surveyObjId}&Prop=CampaignId=${campId}`
            );
            let surveyInterceptUrl = `${process.env.REACT_APP_CORP_ENDPOINT}/templates/bin/interceptpage/intercepthandler.asp?geedgeUid=${userId}&key=${respRaw.hashKey}&redirect=${surveyUrl} `;
            setSurveyURLFinal(surveyInterceptUrl);
            const surveyEndDate =
              "" + getDateFormat(new Date(parseInt(notificationList[i].Enddate.replace(/\/Date\(/g, ""), 10)));
            setSurveyEndDate(surveyEndDate);
            openAfterLoadWindow(1);
            break;
          }
        }
      } else {
        surveyPresent = false;
      }
    }
  };

  const startSurveyCheck = async () => {
    if (!allInfo.announcements.data) {
      dispatch(allActions.announcementsAction.getAnnouncements(allInfo.common.leuId));
    }
  };

  useEffect(() => {
    startSurveyCheck();
  }, []);

  useEffect(() => {
    if (
      !allInfo.learnerTasks.isFailed &&
      !allInfo.peopleInformation.isFailed &&
      allInfo.learnerTasks.data &&
      allInfo.peopleInformation.data
    ) {
      if (GEProducts && GEProducts.length > 0 && Object.keys(GEProducts[0]).length > 0) {
        afterGetLearnerInfo(allInfo.peopleInformation);
      }
    }
  }, [GEProducts, allInfo.common.isTMSCallRequired]);

  useEffect(() => {
    if (
      !allInfo.peopleInformation.isLoading &&
      !allInfo.learnerTasks.isLoading &&
      !allInfo.jwkPublicKey.isLoading
    ) {
      if (
        !allInfo.learnerTasks.isFailed &&
        !allInfo.peopleInformation.isFailed &&
        allInfo.learnerTasks.data &&
        allInfo.peopleInformation.data
      ) {
        afterGetLearnerInfo(allInfo.peopleInformation);
        getBusinessEnglishData(allInfo.common.leuId);

        if (
          allInfo.peopleInformation.data.getpeopleInformation.serviceConfiguration.features.substring(46, 47) === "1"
        ) {
          getNewsFeedData();
        }
      }
    }
  }, [allInfo.peopleInformation, allInfo.learnerTasks, allInfo.jwkPublicKey]);

  useEffect(() => {
    if (!allInfo.announcements.isLoading) {
      if (!allInfo.announcements.isFailed && allInfo.announcements.data) {
        afterGetAnnouncements(allInfo.announcements, allInfo.common.leuId);
      }
    }
  }, [allInfo.announcements]);

  useEffect(() => {
    if (!allInfo.tmsCourses.isLoading && !allInfo.currentCourseDetails.isLoading) {
      if (!allInfo.tmsCourses.isFailed && allInfo.tmsCourses.data) {
        if (!allInfo.currentCourseDetails.isFailed) {
          let activeCourseId;
          if (allInfo.tmsCourses.data.getTMSGetCourse.length > 0) {
            activeCourseId = allInfo.tmsCourses.data.getTMSGetCourse.filter(
              (course: { status: string }) => course.status == "1" || course.status == "2" || course.status == "3" || course.status=="5"
            );
            activeCourseId =
              activeCourseId.length > 0
                ? allInfo.tmsCourses.data.getTMSGetCourse[allInfo.tmsCourses.data.getTMSGetCourse.length - 1].courseId
                : "0";
          } else {
            activeCourseId = "0";
          }
          getActiveCourse(allInfo.common.leuId, activeCourseId);
        }
      }
    }
  }, [allInfo.tmsCourses, allInfo.currentCourseDetails]);

  useEffect(() => {
    if (!allInfo.newsFeedAPI.isLoading) {
      if (!allInfo.newsFeedAPI.isFailed) {
        setNewsFeedList(allInfo.newsFeedAPI.data || []);
      }
    }
  }, [allInfo.newsFeedAPI]);

  useEffect(() => {
    if (!allInfo.learnerJWToken.isLoading) {
      if (!allInfo.learnerJWToken.isFailed && allInfo.learnerJWToken.data) {
        if (!allInfo.tmsCourses.isLogoutLoading && allInfo.common.isTMSCallRequired) {
          // <COMMENTING OUT CODE FOR TMS DEPENDENCY>
          callTMSLogout();
        }
      }
    }
  }, [allInfo.learnerJWToken, allInfo.common.isTMSCallRequired]);

  useEffect(() => {
    if (!allInfo.tmsCourses.isLoginLoading) {
      if (allInfo.tmsCourses.isLoginSucceeded) {
        if (!allInfo.tmsCourses.isLoading) {
          if (!allInfo.tmsCourses.isFailed && allInfo.tmsCourses && allInfo.tmsCourses.data) {
            afterGetTMSCourse(GEProducts, allInfo.tmsCourses);
          } else {
            if (GEProducts && GEProducts.length > 0 && Object.keys(GEProducts[0]).length > 0) {
              setLicensesList(filterRedundantGECourses(GEProducts));
            }
          }
        }
      } else {
        dispatch(allActions.tmsCoursesAction.stopAPIPropagation());
      }
    }
  }, [allInfo.tmsCourses]);

  useEffect(() => {
    if (!allInfo.tmsCourses.isLogoutLoading) {
      if (
        allInfo.learnerJWToken &&
        allInfo.learnerJWToken.data &&
        allInfo.learnerJWToken.data.getLearnerJwtoken &&
        allInfo.common.isTMSCallRequired
      ) {
        // <COMMENTING OUT CODE FOR TMS DEPENDENCY>
        callTMSLogin(allInfo.learnerJWToken.data.getLearnerJwtoken);
      }
    }
  }, [allInfo.tmsCourses.isLogoutLoading, allInfo.common.isTMSCallRequired]);

  useEffect(() => {
    if (!allInfo.tmsCourses.isLoginLoading) {
      if (!allInfo.tmsCourses.isLoginSucceeded) {
        if (GEProducts && GEProducts.length > 0 && Object.keys(GEProducts[0]).length > 0) {
          setLicensesList(GEProducts);
        }
      } else {
        if (allInfo.tmsCourses && !allInfo.tmsCourses.data) {
          getTMSListInfo();
        }
      }
    }
  }, [allInfo.tmsCourses.isLoginLoading]);

  useEffect(() => {
    if (
      licensesList.filter((lic: any) => lic.productId === "13").length > 0 &&
      !sessionStorage.getItem("isDemoUser")
    ) {
      promoteDashboard(licensesList, "13");
      
    }
  }, [licensesList]);

  // Useeffect for Loader
  useEffect(() => {
    if (
      !allInfo.common.isLoading &&
      !allInfo.peopleInformation.isLoading &&
      !allInfo.learnerTasks.isLoading &&
      !allInfo.learnerJWToken.isLoading &&  
      !allInfo.tmsCourses.isLoading &&
      !allInfo.tmsCourses.isLogoutLoading &&
      !allInfo.tmsCourses.isLoginLoading &&
      !allInfo.jwkPublicKey.isLoading &&
      !allInfo.renewalInformation.isLoading &&
      !allInfo.currentCourseDetails.isLoading &&
      (!allInfo.currentSoloCourseDetails.isLoading || sessionStorage.getItem("isDemoUser")) &&
      (sessionStorage.getItem("isDemoUser") ||
        licensesList.filter((lic: any) => lic.productId === "25").length <= 0 ||
        (licensesList &&
          licensesList.filter((lic: any) => lic.productId === "25").length > 0 &&
          !allInfo.createSessionService.isLoading)) &&
      typeof allInfo.common.isRenewalInterceptRequired !== "undefined"
    ) {
      setLoaderFlag(false);
    } else {
      setLoaderFlag(true);
    }
  }, [allInfo]);

  const handleSurveyClose = () => {
    setSurveyWindowOpen(false);
  };

  const openSurveyLink = () => {
    window.open(surveyURLFinal, "_self");
    setSurveyWindowOpen(false);
  };

  const openAfterLoadWindow = (type: number) => {
    switch (type) {
      case 1:
        // Survey window
        if (surveyPresent) {
          if (!sessionStorage.getItem("surShwn")) {
            setSurveyWindowOpen(true);
            sessionStorage.setItem("surShwn", "true");
          }
        }
        break;
      case 2:
        // Another window
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    document.title = "Halo - Home";
  }, []);

  const getButtonText = (pd: any, productList: any[]) => {
    if (pd.productId !== "") {
      return handleProductId(pd, productList);
    } else {
      return handleProductName(pd, productList);
    }
  }
  
  const handleProductId = (pd: any, productList: any[]) => {
    if (pd.productId === "13" && !sessionStorage.getItem("isDemoUser")) {
      return translate("button_GoText");
    } else if (pd.productId === "5" || pd.productId === "6") {
      return handleTestState();
    } else {
      return findProductById(pd, productList);
    }
  }
  
  const handleProductName = (pd: any, productList: any[]) => {
    return findProductByName(pd, productList);
  }
  
  const handleTestState = () => {
    switch (stepAuthorizationData?.testState) {
      case "InProgress":
        return translate("myschedule_status_inprogress");
      case "Completed":
        return translate("button_GetResult");
      case "NoTest":
        return translate("button_GetStarted");
      default:
        return translate("button_GetLoading");
    }
  }
  
  const findProductById = (pd: any, productList: any[]) => {
    const product = productList.find((product: any) => product.productId === pd.productId);
    return translate(product ? product.productBtnText : "button_GetStarted");
  }
  
  const findProductByName = (pd: any, productList: any[]) => {
    const product = productList.find((product: any) => product.productName === pd.productName);
    return translate(product ? product.productBtnText : "button_GetStarted");
  }

const arrangedLicenses =  moveReachLast(licensesList,"Reach")
  return (sessionStorage.getItem("skipManagerEmail") === "true" ||
    allInfo.common.managerEmail ||
    !allInfo.common.isManagerEmailRequired) &&
    (!allInfo.common.isRenewalInterceptRequired || sessionStorage.getItem("RenwalIntercept") !== "true") ? (
    <React.Fragment>
      <Dialog
        TransitionComponent={Transition}
        onClose={handleSurveyClose}
        aria-labelledby="Take survey"
        aria-aria-label="Take survey"
        open={surveyWindowOpen}
        maxWidth={"xs"}
      >
        <DialogTitle>
          <div className="feedback-header">{translate("learnerhome_survey_header")}</div>
        </DialogTitle>
        <div className="survey-modal-container">
          <div className="survey-modal-body text-center">
            <div className="survey-modal-img w35p display-none">
              <img src={window.location.origin + "/images/" + "Product_Illustrations/sprint-business-skills.svg"} alt="product"></img>
            </div>
            <div className="survey-modal-content w85p float-none">
              <span>{translate("learnerhome_survey_line1")}</span> <span>{translate("learnerhome_survey_line2")} </span>
              <span className="feedback-date">{surveyEndDate}.</span>
              <br />
              <br />
              {translate("learnerhome_survey_line3")}
              <div className="survey-buttons-container">
                <Button
                  className="survey-button contained left"
                  variant="contained"
                  color="primary"
                  onClick={openSurveyLink}
                >
                  {translate("learnerhome_survey_button1")}
                </Button>
                <Button
                  className="survey-button outlined right"
                  color="primary"
                  variant="outlined"
                  onClick={handleSurveyClose}
                >
                  {translate("learnerhome_survey_button2")}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
      <Toaster
        open={toastOptions.toastOpen}
        severity={toastOptions.toastSeverity}
        toasterClosed={toasterHandle}
        messageKey={toastOptions.toastMessageKey}
      />
      <div className="LearnerHomeContainer">
        <div className="LearnerBody">
          <H2SummaryBlock
            title={
              <React.Fragment>
                {translate("login_welcome")}{" "}
                {allInfo.peopleInformation.data && allInfo.peopleInformation.data.getpeopleInformation.firstName}!
              </React.Fragment>
            }
            summary={translate("get_startedText")}
          ></H2SummaryBlock>
          <div></div>
          <div className="activeCourse_container">
            {licensesList.filter((lic: any) => lic.productId === "13").length > 0 &&
            !sessionStorage.getItem("isDemoUser") ? (
              <div className="allHeaders">
                <h1 className="headeralign"> {translate("admin_dashboard_header")} </h1>
                <h1 className="headeralign forDesk"> {translate("active_course")} </h1>
              </div>
            ) : (
              <div className="allHeaders">
                <h1 className="headeralign"> {translate("active_course")} </h1>
              </div>
            )}
            <div className="productCardsContainer PageContainerBlock">
              {arrangedLicenses &&
                arrangedLicenses.length > 0 &&
                Object.keys(arrangedLicenses[0]).length > 0 &&
                arrangedLicenses.map((pd: any, index: number) => {
                  
                  return (
                    ((pd.show === "1" && !sessionStorage.getItem("isDemoUser")) ||
                      (sessionStorage.getItem("isDemoUser") &&
                        dynamicCardProducts.filter((products) => products === pd.productId).length > 0)) && 
                      <React.Fragment key={getRandomNumber(index)}>
                        {licensesList.filter((lic: any) => lic.productId === "13").length > 0 &&
                          index == 1 &&
                          !sessionStorage.getItem("isDemoUser") && (
                            <div className="h_a_new forMob">
                              <h1 className="headeralign  forMob"> {translate("active_course")} </h1>
                            </div>
                          )}
                        {loaderFlag ? <ProductCardSkeleton/> :
                         <ProductCard
                          key={index}
                          title={pd.productName}
                          productId={pd.productId}
                          summary={
                            pd.productId === "21"
                              ? translate(
                                  productList.filter((product: any) => product.productId === pd.productId)[0]
                                    ? productList.filter((product: any) => product.productId === pd.productId)[0]
                                        .productDescription
                                    : "product_lorem_solo_desc"
                                )
                              : pd.productId === "25"
                              ? translate("product_elevate_desc")
                              : pd.productId === "13"
                              ? translate("product_dashboard_desc")
                              : translate(
                                  productList.filter((product: any) => product.productId === pd.productId)[0]
                                    ? productList.filter((product: any) => product.productId === pd.productId)[0]
                                        .productDescription
                                    : "product_lorem_desc"
                                )
                          }
                          iconFontClass="string"
                          headColorClass="string"
                          roundButtonText="Buy Now"
                          redirectURL={
                            pd.productId === "1" ? `${process.env.REACT_APP_PRODUCT_URL_ID_1}` : pd.redirectURL
                          }
                          flatButtonText={getButtonText(pd, productList)}
                          activeCourseButtonText={
                            pd.productId !== ""
                              ? translate(
                                  productList.filter((product: any) => product.productId === pd.productId)[0]
                                    ? productList.filter((product: any) => product.productId === pd.productId)[0]
                                        .productCourseBtnText
                                    : "button_Resume"
                                )
                              : translate(
                                  productList.filter((product: any) => product.productName === pd.productName)[0]
                                    ? productList.filter((product: any) => product.productName === pd.productName)[0]
                                        .productCourseBtnText
                                    : "button_Resume"
                                )
                          }
                          activeCourseCertificateButtonText={
                            pd.productId !== ""
                              ? translate(
                                  productList.filter((product: any) => product.productId === pd.productId)[0]
                                    ? productList.filter((product: any) => product.productId === pd.productId)[0]
                                        .productCertificateBtnText
                                    : "button_ViewDetails"
                                )
                              : translate(
                                  productList.filter((product: any) => product.productName === pd.productName)[0]
                                    ? productList.filter((product: any) => product.productName === pd.productName)[0]
                                        .productCertificateBtnText
                                    : "button_ViewDetails"
                                )
                          }
                          activeCourseContinueStudyingButtonText={
                            pd.productId !== ""
                              ? translate(
                                  productList.filter((product: any) => product.productId === pd.productId)[0]
                                    ? productList.filter((product: any) => product.productId === pd.productId)[0]
                                        .productContinueStudyingBtnText
                                    : "button_ContinueStudying"
                                )
                              : translate(
                                  productList.filter((product: any) => product.productName === pd.productName)[0]
                                    ? productList.filter((product: any) => product.productName === pd.productName)[0]
                                        .productContinueStudyingBtnText
                                    : "button_ContinueStudying"
                                )
                          }
                          productcardclass= {pd.productId === '15'?"reachCard": "productcard"}
                          prodcardimage={
                            pd.productId !== ""
                              ? productList.filter((product: any) => product.productId === pd.productId)[0]
                                ? productList.filter((product: any) => product.productId === pd.productId)[0]
                                    .productImgUrl
                                : "Product_Illustrations/evolve-relocation-language.svg"
                              : productList.filter((product: any) => product.productName === pd.productName)[0]
                              ? productList.filter((product: any) => product.productName === pd.productName)[0]
                                  .productImgUrl
                              : "Product_Illustrations/evolve-relocation-language.svg"
                          }
                        />
                      }
                      </React.Fragment>
                  ) ;
                })}
            </div>
          </div>
          {!allInfo.common.isNewsfeedTzBlocked && props.isEnglishUser && !hideNewsFeed && (
            <DailyNewsFeedComponent data={newsFeedList} />
          )}
          <RecomendedCarouselComponent />
        </div>
      </div>
    </React.Fragment>
  ) : (
    <div className="intercept-page">
      {sessionStorage.getItem("skipManagerEmail") !== "true" &&
        !allInfo.common.managerEmail &&
        allInfo.common.isManagerEmailRequired && (
          <div className="manager-email">
            <ManagerEmailPage></ManagerEmailPage>
          </div>
        )}
      {sessionStorage.getItem("RenwalIntercept") !== "skip" &&
        allInfo.common.isRenewalInterceptRequired &&
        (allInfo.common.managerEmail ||
          sessionStorage.getItem("skipManagerEmail") === "true" ||
          !allInfo.common.isManagerEmailRequired) && (
          <div className="intercept-page">
            <RenewalIntercept setLoaderFlag={setLoaderFlag}></RenewalIntercept>
          </div>
        )}
    </div>
  );
};

export default LearnerHome;
